import { Injectable } from '@angular/core';
import { ApiInterface } from '../api-interface';
import { ApiService } from '../api.service';
import { Observable } from 'rxjs';
import {
  AtividadeEconomicaDTO,
  AtividadeEconomicaResponseDTO,
} from '../../models/configuracoes/atividade-economica.model';

@Injectable({
  providedIn: 'root',
})
export class AtividadeEconomicaService implements ApiInterface {
  constructor(private apiService: ApiService) {}

  get<T>(url: string, data?: any): Observable<AtividadeEconomicaResponseDTO> {
    const queryParams = this.apiService.buildQueryParams(data);
    const patch = queryParams ? `${url}?${queryParams}` : url;
    return this.apiService.read<AtividadeEconomicaResponseDTO>(patch);
  }

  getById<T>(url: string): Observable<AtividadeEconomicaDTO> {
    return this.apiService.read<AtividadeEconomicaDTO>(url);
  }

  post<T>(
    url: string,
    data: AtividadeEconomicaDTO
  ): Observable<AtividadeEconomicaDTO> {
    return this.apiService.create<AtividadeEconomicaDTO>(url, data);
  }

  put<T>(
    url: string,
    data: AtividadeEconomicaDTO
  ): Observable<AtividadeEconomicaDTO> {
    return this.apiService.update<AtividadeEconomicaDTO>(url, data);
  }

  delete<T>(url: string): Observable<any> {
    return this.apiService.delete(url);
  }
}
